var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTourism(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DDE5B6",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8486 13C34.1926 13 34.4441 13.1074 34.666 13.3301L34.668 13.332C34.8931 13.557 35 13.8096 35 14.1504C35 14.4907 34.8937 14.7426 34.6709 14.9668L30.0107 19.6045L29.6426 19.9707L29.7305 20.4824L31.9629 33.5059L31.3115 34.1582L27.167 24.3916L26.5869 23.0264L25.5381 24.0762L21.0195 28.6025L20.6562 28.9658L20.7412 29.4736L21.5049 34.0508L21.2227 34.333L18.7607 29.6768L18.6172 29.4062L18.3467 29.2617L13.6641 26.7666L13.9443 26.4863L18.5518 27.2715L19.0615 27.3584L19.4268 26.9922L23.9463 22.4668L24.9902 21.4209L23.6318 20.8408L13.8779 16.6709L14.5176 16.0332L27.5303 18.2686L28.043 18.3564L28.4092 17.9873L33.0312 13.3301C33.2532 13.1074 33.5047 13 33.8486 13Z",
    stroke: "#72924E",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourism);
export default __webpack_public_path__ + "static/media/tourism.0c65bcb7d58944f726edf31ca30b1486.svg";
export { ForwardRef as ReactComponent };